import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer, useCallback, useMemo } from 'react';
// utils
import axios from '../utils/axios';
import localStorageAvailable from '../utils/localStorageAvailable';
//
import { isValidToken, setSession } from './utils';

// ----------------------------------------------------------------------

// NOTE:
// We only build demo at basic level.
// Customer will need to do some extra handling yourself if you want to extend the logic and other features...

// ----------------------------------------------------------------------

const initialState = {
  isInitialized: false,
  isAuthenticated: false,
  user: null,
};

const reducer = (state, action) => {
  if (action.type === 'INITIAL') {
    return {
      isInitialized: true,
      isAuthenticated: action.payload.isAuthenticated,
      user: action.payload.user,
    };
  }
  if (action.type === 'LOGIN') {
    return {
      ...state,
      isAuthenticated: true,
      user: action.payload.user,
    };
  }
  if (action.type === 'REGISTER') {
    return {
      ...state,
      isAuthenticated: true,
      user: action.payload.user,
    };
  }
  if (action.type === 'LOGOUT') {
    return {
      ...state,
      isAuthenticated: false,
      user: null,
    };
  }

  return state;
};

// ----------------------------------------------------------------------

export const AuthContext = createContext(null);

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const storageAvailable = localStorageAvailable();

  const initialize = useCallback(async () => {
    try {
      const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken);

        // const response = await axios.get('/api/account/my-account');
        // const { user } = response.data;

        const user = {
          id: "8864c717-587d-472a-929a-8e5f298024da-0",
          displayName: "Jaydon Frankie",
          email: "ethiopia@loyyal-partnerhub.com",
          password: "gdrye",
          photoURL: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_default.jpg",
          phoneNumber: "+40 777666555",
          country: "United States",
          address: "90210 Broadway Blvd",
          state: "California",
          city: "San Francisco",
          zipCode: "94116",
          about: "Praesent turpis. Phasellus viverra nulla ut metus varius laoreet. Phasellus tempus.",
          role: "admin",
          isPublic: true
        }

        dispatch({
          type: 'INITIAL',
          payload: {
            isAuthenticated: true,
            user,
          },
        });
      } else {
        dispatch({
          type: 'INITIAL',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    } catch (error) {
      console.error(error);
      dispatch({
        type: 'INITIAL',
        payload: {
          isAuthenticated: false,
          user: null,
        },
      });
    }
  }, [storageAvailable]);

  useEffect(() => {
    initialize();
  }, [initialize]);

  // LOGIN
  const login = useCallback(async (email, password) => {
    // const response = await axios.post('/auth/login', {
    //   username: email,
    //   password: password,
    // });
    // const accessToken = response.data.body.token;
    const accessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJjb25zdW1lciIsImF1dGhvcml6ZWQiOnRydWUsImV4cCI6MjA4NDEzOTYwNiwibmFtZSI6IlZhcG91cndhcmUiLCJzdWIiOiJ2YXBvdXJ3YXJlQGxveXlhbC5jb20iLCJ1c2VySWRlbnRpZmllciI6IjZ0Z3hnMTQzeE8xVnJXZU9MWndmZFQxZWsycDRFdiJ9.fJK8Aip6uQl89uxdQvBQYzKIYQ_U8AgHjuFIwAFHxtg';
    const user = {
      id: "8864c717-587d-472a-929a-8e5f298024da-0",
      displayName: "Anbassa Tesfaye",
      email: "ethiopia@loyyal-partnerhub.com",
      password: "gdrye",
      photoURL: "https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_default.jpg",
      phoneNumber: "+251 777666555",
      country: "Ethiopia",
      address: "90210 Broadway Blvd",
      state: "Addis Ababa",
      city: "Addis Ababa",
      zipCode: "1165",
      about: "",
      role: "admin",
      isPublic: true
    }

    setSession(accessToken);

    dispatch({
      type: 'LOGIN',
      payload: {
        user,
      },
    });
  }, []);

  // REGISTER
  const register = useCallback(async (email, password, firstName, lastName) => {
    const response = await axios.post('/api/account/register', {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    localStorage.setItem('accessToken', accessToken);

    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  }, []);

  // LOGOUT
  const logout = useCallback(() => {
    setSession(null);
    dispatch({
      type: 'LOGOUT',
    });
  }, []);

  const memoizedValue = useMemo(
    () => ({
      isInitialized: state.isInitialized,
      isAuthenticated: state.isAuthenticated,
      user: state.user,
      method: 'jwt',
      login,
      register,
      logout,
    }),
    [state.isAuthenticated, state.isInitialized, state.user, login, logout, register]
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}
